var map = {
	"./lewis-hamilton-feeds-kangaroos.md": [
		"623f",
		"chunk-2d0cef45"
	],
	"./message-from-michelle-obama.md": [
		"11b0",
		"chunk-2d0aab24"
	],
	"./youtubers-for-human-rights.md": [
		"cb96",
		"chunk-2d2218b2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "24ec";
module.exports = webpackAsyncContext;